import { useState } from 'react';
import { useUser, useAuth, useClerk } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Container, Typography } from '@mui/material';
import { CheckCircleOutline, ExitToApp } from '@mui/icons-material';

import PageHeader from '../components/PageHeader';
import MiniFooter from '../components/shared/MiniFooter';
import logService from '../services/wss/logService3';
import onboardingService from '../services/OnboardingService';

const _name = 'CheckoutCancelledPage';

export default function CheckoutCancelledPage() {
    const { user } = useUser();
    const { getToken } = useAuth();
    const { signOut } = useClerk();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const handleContinueFree = async () => {
        setLoading(true);
        await onboardingService.setTier(user.id, getToken, 'free');
        localStorage.setItem('jerny_selected_tier', 'free');
        navigate('/welcome');
    };

    const handleLeave = async () => {
        try {
            setLoading(true);
            const token = await getToken();

            await onboardingService.abort(token);
        } catch (ex) {
            logService.logError(`${_name}.handleLeave: ex=${ex.message}`);
        } finally {
            await signOut();
            navigate('/');
        }
    };

    return (
        <Box id="checkout-cancelled-root" sx={{ bgcolor: '#0d0d1a', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box id="checkout-cancelled-header" sx={{ flexShrink: 0 }}>
                <Container maxWidth="lg" sx={{ pt: 1, pb: 0 }}>
                    <PageHeader hideIcon={true} title="Payment cancelled" subtitle="No worries — what would you like to do?" />
                </Container>
            </Box>

            <Box id="checkout-cancelled-content" sx={{ flex: 1, minHeight: 0, paddingTop: '40px', textAlign: 'center' }}>
                <Typography sx={{ color: '#b0c8e0', fontSize: '1rem', mb: 4 }}>
                    You cancelled the Jerny Standard checkout. You can continue with a free account or leave.
                </Typography>

                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                    <Button
                        variant="contained"
                        startIcon={<CheckCircleOutline />}
                        onClick={handleContinueFree}
                        disabled={loading}
                        sx={{ bgcolor: '#66b2ff', color: '#0d0d1a', '&:hover': { bgcolor: '#4a9fe8' }, minWidth: 260 }}
                    >
                        Continue with Free
                    </Button>

                    <Button
                        variant="outlined"
                        startIcon={<ExitToApp />}
                        onClick={handleLeave}
                        disabled={loading}
                        sx={{
                            borderColor: '#ff6b6b',
                            color: '#ff6b6b',
                            '&:hover': { borderColor: '#ff4444', color: '#ff4444' },
                            minWidth: 260,
                        }}
                    >
                        Leave
                    </Button>
                </Box>
            </Box>

            <MiniFooter />
        </Box>
    );
}
